<!-- The message a click is opening, until it is on screen: the reader's skeleton with the real subject and date from
     the list row, every block where the reader puts its part. Whatever the pane held (a message or a folder) stays
     alive underneath, hidden, so a cancelled open shows it again unchanged. -->
@if (pendingMessage(); as pending) {
  <div class="pending-message" data-testid="mail-reader-pending" role="status" aria-busy="true" aria-label="Loading message">
    <app-mail-reader-skeleton
      [message]="pending"
      [knowledge]="pendingKnowledgeShown()"
      [workspace]="pendingWorkspace()"
      [handover]="pendingHandover()"
      [activity]="pendingActivity()"
    />
  </div>
}

@if (!item && !pendingMessage()) {
  <div class="empty-state">
    @if (section() === 'folders') {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-mail-folder.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No folder selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewFolder()">
          <app-icon name="inbox-folder" />
          Create a new inbox folder
        </app-button2>
      </app-no-content-stub>
    } @else {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-mail.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No message selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewMessage()">
          <app-icon name="button-nav-compose" />
          Send a message
        </app-button2>
      </app-no-content-stub>
    }
  </div>
}

@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.MESSAGE_FOLDER) {
      <app-message-folder-form
        id="message-folder-form"
        [style.display]="pendingMessage() ? 'none' : null"
        [folder]="asMessageFolder(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.MESSAGE) {
      <app-message2-form
        id="message2-form"
        [style.display]="pendingMessage() ? 'none' : null"
        [message]="asMessage(item)"
        [autoSaveAllowed]="false"
        (close)="handleFormClose($event)"
        />
    }
  }
}
